import React from 'react';
import moment from "moment-timezone";
import CustomCellRender from "components/common/CustomCellRender";

export const laoExportLaodPlanColumns = {
    columnOrder: [
        {
            title: 'cubication_id', field: "cubicationId",
            render: rowData => {
                return <CustomCellRender id="cubicationId" value={rowData?.cubicationId} />
            }
        },
        {
            title: 'id_position', field: "idPosition",
            render: rowData => {
                return <CustomCellRender id="idPosition" value={rowData?.idPosition} />
            }
        },
        {
            title: 'plant_origin', field: "orderOriginId",
            render: rowData => {
                return <CustomCellRender id="orderOriginId" value={rowData?.orderOrigin?.id} />
            }
        },
        {
            title: 'dest_plant', field: "orderDestinationId",
            render: rowData => {
                return <CustomCellRender id="orderDestinationId" value={rowData?.orderDestination?.id} />
            }
        },
        {
            title: 'customer_code', field: "customerCode",
            render: rowData => {
                return <CustomCellRender id="customerCode" value={rowData?.customerCode} />
            }
        },
        {
            title: 'customer_name', field: "customerName",
            render: rowData => {
                return <CustomCellRender id="customerName" value={rowData?.customerName} />
            }
        },
        {
            title: 'destination_country', field: "destinationCountry",
            render: rowData => {
                return <CustomCellRender id="destinationCountry" value={rowData?.orderDestination?.country} />
            }
        },
        {
            title: 'storage_location', field: "storageLocation",
            render: rowData => {
                return <CustomCellRender id="storageLocation" value={rowData?.storageLocation} />
            }
        },
        {
            title: 'availability_date', field: "availabilityDate",
            render: rowData => {
                return <CustomCellRender id="availabilityDate" value={rowData?.availabilityDate} />
            }
        },
        {
            title: 'sku', field: "materialNum",
            render: rowData => {
                return <CustomCellRender id="materialNum" value={rowData?.materialNum} />
            }
        },
        {
            title: 'material_description', field: "itemDesc",
            render: rowData => {
                return <CustomCellRender id="itemDesc" value={rowData?.itemDesc} />
            }
        },
        {
            title: 'cubic_quantity', field: "packedQty",
            render: rowData => {
                return <CustomCellRender id="packedQty" value={rowData?.packedQty} />
            }
        },
        {
            title: 'volume_m3', field: "packedQtyVolume",
            render: rowData => {
                return <CustomCellRender id="packedQtyVolume" value={rowData?.packedQtyVolume} />
            }
        },
        {
            title: 'pallets', field: "palletsQty",
            render: rowData => {
                return <CustomCellRender id="palletsQty" value={rowData?.palletsQty} />
            }
        },
        {
            title: 'gross_weight', field: "grossWeight",
            render: rowData => {
                return <CustomCellRender id="grossWeight" value={rowData?.grossWeight} />
            }
        },
        {
            title: 'total_value', field: "totalValue",
            render: rowData => {
                return <CustomCellRender id="totalValue" value={rowData?.totalValue} />
            }
        },
        {
            title: 'weight_unit', field: "weightUnit",
            render: rowData => {
                return <CustomCellRender id="weightUnit" value={rowData?.weightUnit} />
            }
        },
        {
            title: 'container', field: "container",
            render: rowData => {
                return <CustomCellRender id="container" value={rowData?.container} />
            }
        },
        {
            title: 'cnt_type', field: "containerType",
            render: rowData => {
                return <CustomCellRender id="containerType" value={rowData?.containerType} />
            }
        },
        {
            title: 'mode', field: "mode",
            render: rowData => {
                return <CustomCellRender id="mode" value={rowData?.mode} />
            }
        },
        {
            title: 'po_so_export', field: "exportOrderNum",
            render: rowData => {
                return <CustomCellRender id="exportOrderNum" value={rowData?.exportOrderNum} />
            }
        },
        {
            title: 'po_so_ftz', field: "ftzOrderNum",
            render: rowData => {
                return <CustomCellRender id="ftzOrderNum" value={rowData?.ftzOrderNum} />
            }
        },
        {
            title: 'load_date', field: "loadDate",
            render: rowData => {
                return <CustomCellRender id="loadDate" value={rowData?.loadDate} />
            }
        },
        {
            title: 'carrier', field: "carrier",
            render: rowData => {
                return <CustomCellRender id="carrier" value={rowData?.carrier} />
            }
        },
        {
            title: 'shipping_line', field: "shippingLine",
            render: rowData => {
                return <CustomCellRender id="shippingLine" value={rowData?.shippingLine} />
            }
        },
        {
            title: 'booking_number', field: "bookingNumber",
            render: rowData => {
                return <CustomCellRender id="bookingNumber" value={rowData?.bookingNumber} />
            }
        },
        {
            title: 'cutt_of_documental', field: "cuttOfDocumental",
            render: rowData => {
                return <CustomCellRender id="cuttOfDocumental" value={rowData?.cuttOfDocumental} />
            }
        },
        {
            title: 'etd', field: "etd",
            render: rowData => {
                return <CustomCellRender id="etd" value={rowData?.etd} />
            }
        },
        {
            title: 'eta', field: "eta",
            render: rowData => {
                return <CustomCellRender id="eta" value={rowData?.eta} />
            }
        },
        {
            title: 'comments', field: "comments",
            render: rowData => {
                return <CustomCellRender id="comments" value={rowData?.comments} />
            }
        },
        {
            title: 'lane_number', field: "laneNumber",
            render: rowData => {
                return <CustomCellRender id="laneNumber" value={rowData?.laneNumber} />
            }
        },
        {
            title: 'delivery', field: "delivery",
            render: rowData => {
                return <CustomCellRender id="delivery" value={rowData?.delivery} />
            }
        },
        {
            title: 'load_number', field: "loadNumber",
            render: rowData => {
                return <CustomCellRender id="loadNumber" value={rowData?.loadNumber} />
            }
        },
        {
            title: 'invoice', field: "billingDocNum",
            render: rowData => {
                return <CustomCellRender id="billingDocNum" value={rowData?.billingDocNum} />
            }
        },
        {
            title: 'invoice_quantity', field: "invoiceQty",
            render: rowData => {
                return <CustomCellRender id="invoiceQty" value={rowData?.invoiceQty} />
            }
        }
    ],
    columnConfiguration: (d) => {
        return {
            orderOriginId: d?.orderOrigin?.id ? d?.orderOrigin?.id : '-',
            orderDestinationId: d?.orderDestination?.id ? d.orderDestination.id : '-',
            destinationCountry: d?.orderDestination?.country ? d.orderDestination.country : '-',
            availabilityDate: d?.availabilityDate ? moment(d.availabilityDate).format(`DD-MM-YYYY`) : '-',
            loadDate: d?.loadDate ? moment(d.loadDate).format(`DD-MM-YYYY`) : '-',
            etd: d?.etd ? moment(d.etd).format(`DD-MM-YYYY`) : '-',
            eta: d?.eta ? moment(d.eta).format(`DD-MM-YYYY`) : '-'
        }
    }
};